import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import statesUS from "states-us";

const states = statesUS.filter(
    s =>
        ![
            "Guam",
            "Virgin Islands",
            "Northern Mariana Islands",
            "Puerto Rico",
            "American Samoa",
            "Palau",
        ].includes(s.name)
);

const StatesCheckboxInput = ({ fieldName }) => {
    const { register, setValue } = useFormContext();
    const [selectAll, setSelectAll] = useState(false);

    const onSelectAllChange = () => {
        const newValue = !selectAll;
        setSelectAll(newValue);

        if (!newValue) {
            setValue(fieldName, []);
            return;
        }

        const allStateValues = states.map(state => state.abbreviation);
        setValue(fieldName, allStateValues);
    };

    return (
        <Row>
            <Col xs={12}>
                <Form.Check
                    type="checkbox"
                    size="lg"
                    id="select_all"
                    onChange={onSelectAllChange}
                    value={selectAll}
                    label="Select All"
                />
            </Col>
            {states.map(state => (
                <Col key={`${fieldName}_${state.abbreviation}`} md={4}>
                    <Form.Check
                        type="checkbox"
                        size="lg"
                        id={state.abbreviation}
                        value={state.abbreviation}
                        label={state.name}
                        {...register(fieldName, {
                            setValueAs: v => v || null,
                        })}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default StatesCheckboxInput;
